export default {
  state: {
    dialogDisplay: false,
    dialogHeaderText: null,
    dialogContentText: null,
    dialogClassBtn2: 'fs-confirm',
    dialogDisplayBtn: 'both',
    DialogUserConfirm: false,
    // dialogPath: null,
    // dialogReload: null,
    // dialogIcon: null,
    DisplayDialogPreorder: false,
    DialogMinimumPrice: false,
    DialogOverDistance: false
  },
  mutations: {
    setDialogUserConfirm (state, payload) {
      state.DialogUserConfirm = payload
    },
    setConfirmDialog (state, payload) {
      state.dialogDisplay = (typeof payload[0] === 'undefined') ? null : payload[0]
      state.dialogHeaderText = (typeof payload[1] === 'undefined') ? null : payload[1]
      state.dialogContentText = (typeof payload[2] === 'undefined') ? null : payload[2]
      state.dialogClassBtn2 = (typeof payload[3] === 'undefined') ? 'fs-confirm' : payload[3]
      state.dialogDisplayBtn = (typeof payload[4] === 'undefined') ? 'both' : payload[4]
      // state.dialogPath = (typeof payload[3] === 'undefined') ? null : payload[3]
      // state.dialogReload = (typeof payload[4] === 'undefined') ? null : payload[4]
      // state.dialogIcon = (typeof payload[5] === 'undefined') ? null : payload[5]
    }
  },
  actions: {
    setDisplayDialogPreorder ({state}, payload) {
      // payload = true -> set alert first time only
      state.DisplayDialogPreorder = payload
    },
    setDialogMinimumPrice ({state}, payload) {
      // payload = true -> set alert first time only
      state.DialogMinimumPrice = payload
    },
    setDialogOverDistance ({state}, payload) {
      // payload = true -> set alert first time only
      state.DialogOverDistance = payload
    }
  },
  getters: {
    DialogUserConfirm (state) {
      return state.DialogUserConfirm
    },
    dialogDisplay (state) {
      return state.dialogDisplay
    },
    dialogHeaderText (state) {
      return state.dialogHeaderText
    },
    dialogContentText (state) {
      return state.dialogContentText
    },
    dialogClassBtn2 (state) {
      return state.dialogClassBtn2
    },
    dialogDisplayBtn (state) {
      return state.dialogDisplayBtn
    },
    // dialogPath (state) {
    //   return state.dialogPath
    // },
    // dialogReload (state) {
    //   return state.dialogReload
    // },
    // dialogIcon (state) {
    //   return state.dialogIcon
    // },
    DisplayDialogPreorder (state) {
      return state.DisplayDialogPreorder
    },
    DialogMinimumPrice (state) {
      return state.DialogMinimumPrice
    },
    DialogOverDistance (state) {
      return state.DialogOverDistance
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dialog/index.js